import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HostBackend } from '../HostBackend.js';
import { GetHeaders } from '../../Components/Admin/Functions/FetchHeaders.js';
import { FilterParkAndUnivers } from '../../Components/Public/Filters/FilterParkAndUnivers.js';
import { Characters } from '../../Pages/Public/Characters.js';
import { Character } from '../../Pages/Public/Character.js';
import { NotFound } from '../../Pages/Public/NotFound.js';

export const RouteCharacters = () => {
    const backend = HostBackend();
    const guest = sessionStorage.getItem('guest');
    const [parks, setParks] = useState([]);
    const [cha, setCha] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const datasParks = await fetch(`${backend}/nav/parks`, GetHeaders(guest));
            const parks = await datasParks.json();
            setParks(parks);
            const dataCha = await fetch(`${backend}/nav/characters`, GetHeaders(guest));
            const cha = await dataCha.json();
            setCha(cha);
        };
        fetchData();
    }, [backend, guest]);
    if (parks.err) window.location.href = '/';
    const navParks = FilterParkAndUnivers(parks);
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/personnages" element={<Characters navParks={navParks} />} />
                {cha.map((el, i) => {
                    return (<Route path={el.route} element={<Character navParks={navParks} id={el.id} slug={el.slug} />} key={i} />)
                })}
                <Route path="*" element={<NotFound navParks={navParks} />} />
            </Routes>
        </BrowserRouter>
    )
}
